export default __webpack_public_path__ + "static/media/nice.b631f0b7.png";